import { FC, Fragment, useEffect, useState } from "react";
import Pagination from "../../../components/particles/pagination/pagination";
import { Container, TruncatedTd } from "./style";
import RetailerPopup from "components/popus/retailer-popup";

import Button from "components/particles/primary-button";
import NoDataFound from "components/particles/no-data-found";
import { useNavigate, useSearchParams } from "react-router-dom";
import edit from "assets/images/edit.svg";
import view from "assets/images/view-icon.svg";
import { siteRoutes } from "utils/helpers/enums/routes.enums";
import { useForm } from "react-hook-form";
import { RetailerListSearchDTO } from "utils/helpers/models/retailer.dto";
import { dispatch } from "store";
import { setModalOpened } from "store/user-slice";
import { useSelector } from "react-redux";
import useRetailers from "./useHook";
import PlaceholderImage from "assets/images/place-img.png";


const Retailer: FC = () => {
  const [retailersData, setRetailersData] = useState<any[]>([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [retailerPaginationState, setRetailerPaginationState] = useState<any>();
  const [searchParams, setSearchParams] = useSearchParams();
  const [selectedRetailer, setSelectedRetailer] = useState<any | null>(null);

  const [searchFilters, setSearchFilters] = useState<RetailerListSearchDTO>({
    status: '',
    name: "",
    mobileNumber: "",
    email: "",
    companyName: "",
  });
  const { isLoading } = useSelector((state: any) => state.user);
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    setValue,
    getValues,
    reset: formReset,
  } = useForm<RetailerListSearchDTO>();
  const search = (filters: RetailerListSearchDTO) => {
    setCurrentPage(1);
    setSearchFilters(filters);

    const queryParams: any = {
      name: filters.name || "",
      mobileNumber: filters.mobileNumber || "",
      companyName: filters.companyName || "",
      status: filters.status || "",
    };

    setSearchParams(queryParams);

    getRetailers(
      setRetailersData,
      {
        ...queryParams,
        limit,
        offset: 0,
      },
      setRetailerPaginationState
    );
  };




  const reset = () => {
    // Reset form
    setValue("name", "");
    setValue("mobileNumber", "");
    setValue("companyName", "");
    setValue("status", "");
    formReset();
    setSearchParams({});


    // Reset internal filters state
    setSearchFilters({
      name: "",
      mobileNumber: "",
      companyName: "",
      status: "",
      email: "",
    });
    setCurrentPage(1);
    // Reset data
    getRetailers(
      setRetailersData,
      { limit, offset: 0 },
      setRetailerPaginationState
    );
  };


  const addRetailer = () => {
    setSelectedRetailer(null);
    dispatch(setModalOpened("Retailer"));
  };

  const { postRetailer, getRetailers, updateUserStatusById } = useRetailers();

  useEffect(() => {
    // getRetailers(setRetailersData, {}, setRetailerPaginationState);
  }, []);

  // const handleViewPage = (id: string) => {
  //   navigate(siteRoutes.retailerView, { state: { id } });
  // };
  const handleViewPage = (id: string) => {
    navigate(siteRoutes.retailerView + `?${searchParams.toString()}`, {
      state: { id },
    });
  };


  const limit = 10;

  const fetchNextRecords = (offset: number, page = 1) => {
    setCurrentPage(page);
    const currentFilters = getValues(); // from useForm()
    getRetailers(
      setRetailersData,
      {
        name: currentFilters.name || "",
        mobileNumber: currentFilters.mobileNumber || "",
        companyName: currentFilters.companyName || "",
        status: currentFilters.status || "",
        limit,
        offset,
      },
      setRetailerPaginationState
    );

    const toTopElement = document.getElementById("toTop");
    if (toTopElement) {
      toTopElement.scrollIntoView({ behavior: "smooth" });
    } else {
      window.scrollTo(0, 0);
    }
  };



  const toggleUserStatus = async (userId: string, status: boolean) => {
    const updatedRetailers = retailersData.map((retailer) =>
      retailer.id === userId ? { ...retailer, status } : retailer
    );
    setRetailersData(updatedRetailers);
    try {
      await updateUserStatusById(userId, status);
    } catch (err) {
      const revertedRetailers = retailersData.map((retailer) =>
        retailer.id === userId ? { ...retailer, status: !status } : retailer
      );
      setRetailersData(revertedRetailers);
    }
  };

  const columns: any = [
    {
      name: "Name",
      class: "",
    },
    {
      name: "Email",
      class: "",
    },
    {
      name: "Phone Number",
      class: "",
    },
    {
      name: "Company Name",
      class: "",
    },
    {
      name: "Address",
      class: "th",
    },
    {
      name: "Status",
      class: "th",
    },
    {
      name: "Actions",
      class: "th",
    },
  ];

  const options = ["", "true", "false"];

  ///////////////////////////////////////////////
  useEffect(() => {
    const name = searchParams.get("name") || "";
    const mobileNumber = searchParams.get("mobileNumber") || "";
    const companyName = searchParams.get("companyName") || "";
    const status = searchParams.get("status") || "";

    const filtersFromParams = {
      name,
      mobileNumber,
      companyName,
      status,
      email: "", // not used but part of DTO
    };

    setValue("name", name);
    setValue("mobileNumber", mobileNumber);
    setValue("companyName", companyName);
    setValue("status", status);
    setSearchFilters(filtersFromParams);

    getRetailers(
      setRetailersData,
      {
        name,
        mobileNumber,
        companyName,
        status,
        limit,
        offset: 0,
      },
      setRetailerPaginationState
    );
  }, [searchParams]);

  /// EDIT 

  const handleEdit = (retailer: any) => {
    setSelectedRetailer(retailer);
    dispatch(setModalOpened("Retailer"));
  };

  const handleUpdateInState = (updatedRetailer:any) => { 
     if (!updatedRetailer || !updatedRetailer.id) {
    console.error("⚠️ Invalid updatedRetailer:", updatedRetailer);
    return;
  }
    setRetailersData((prev) =>
      prev.map((r) =>
        r.id === updatedRetailer.id ? { ...r, ...updatedRetailer } : r
      )
    );
  };


  return (
    <Container id="toTop">
      <div className="title">
        <h1>Retailers list</h1>
        <Button
          title="Add New Retailer"
          onclick={addRetailer}
          width="16.5rem"
          fill="true"
          backgroundcolor="var(--reset-button)"
        />
      </div>
      <div className="search-container">
        <div className="input-fields">
          <input
            type="text"
            placeholder="Search By Name"
            {...register("name")}
          />
          <input
            type="text"
            placeholder="Search By Phone Number"
            {...register("mobileNumber")}
          />
          <input
            type="text"
            placeholder="Search By Company"
            {...register("companyName")}
          />

          <select id="status" {...register("status")}>
            <option value="">Status</option>
            <option value="true">Active</option>
            <option value="false">Inactive</option>
          </select>
        </div>
        <div className="button-fields">
          <Button
            title="Search"
            width="16rem"
            fill="true"
            onclick={handleSubmit(search)}
          />
          <Button
            title="Reset"
            width="16rem"
            fill="true"
            backgroundcolor="var(--reset-button)"
            onclick={handleSubmit(reset)}
          />
        </div>
        {/* <Input /> */}
      </div>
      <div className="data-table">
        <table>
          <thead>
            <tr>
              {columns.map((column: any, index: number) => {
                return (
                  <th className={column.class} key={index}>
                    {column.name}
                  </th>
                );
              })}
            </tr>
          </thead>
          <tbody>
            {retailersData?.length > 0 ? (
              retailersData?.map((item, index) => (
                <tr key={index}>
                  <td>
                    <div
                      style={{
                        display: "flex",
                        gap: "1rem",
                        alignItems: "center",
                        fontSize: "14px",
                      }}
                    >
                      <img src={item.image ? item.image : PlaceholderImage} className="img" alt="img" />
                      {item.firstName || '-'} {' '}
                      {item.lastName}
                    </div>
                  </td>
                  <td>{item.email || '-'}</td>
                  {item.mobileNumber ? (
                    <td>{item.mobileNumber || '-'}</td>
                  ) : (
                    <td>-</td>
                  )}
                  <td>{item.companyName || '-'}</td>
                  <TruncatedTd className="th">
                    {item.physicalAddress || '-'}
                  </TruncatedTd>
                  <td>
                    <label className="toggle-button">
                      <input
                        type="checkbox"
                        checked={item.status}
                        onChange={(e) =>
                          toggleUserStatus(item.id, e.target.checked)
                        }
                      />

                      <span className="slider round"></span>
                    </label>
                  </td>
                  <td className="actions th" style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
                    <div
                      className="view-container"
                      onClick={() => handleViewPage(item?.id)}
                    >
                      <img src={view} alt="img" />
                    </div>
                    <div
                      className="edit-container"
                      onClick={() => handleEdit(item)}
                    >
                      <img src={edit} alt="edit" />
                    </div>

                  </td>
                </tr>
              ))
            ) : (
              <NoDataFound isShow={!isLoading} />
            )}
          </tbody>
        </table>
      </div>
      {/* <RetailerPopup
       retailer={selectedRetailer} 
        refreshRetailers={() => {
         return getRetailers(
            setRetailersData,
            { limit, offset: 0 },
            setRetailerPaginationState
          )
        }}          
      /> */}
      <RetailerPopup
        retailer={selectedRetailer}
        updateList={handleUpdateInState}
        refreshRetailers={() => {
          const currentFilters = getValues(); // from useForm
          const offset = (currentPage - 1) * limit;

          return getRetailers(
            setRetailersData,
            {
              name: currentFilters.name || "",
              mobileNumber: currentFilters.mobileNumber || "",
              companyName: currentFilters.companyName || "",
              status: currentFilters.status || "",
              limit,
              offset,
            },
            setRetailerPaginationState
          );
        }}
      />

      <Fragment>
        <Pagination
          totalRecords={retailerPaginationState?.total || 0}
          perPage={limit}
          handleFetchNextRecords={fetchNextRecords}
          currentPage={currentPage}
        />
      </Fragment>
    </Container >
  );
};

export default Retailer;
